import { withLazyComponent } from './with-lazy-component';
import React from 'react';

const AddressFieldGB = React.lazy(() => import('../components/address-field-gb-backup'));

export default function (dependencies) {
  const { language } = dependencies;

  const html = (props) => {
    const LazyComponent = withLazyComponent(AddressFieldGB);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    validators: [
      function (state, config, globalConfig) {
        if (state.match == 'full') {
          return false;
        } else {
          return language['address-invalid'];
        }
      },
    ],
    config: {
      behaviour: 'text-input',
    },
  };
}
